import { render, staticRenderFns } from "./purchase.vue?vue&type=template&id=db9a303e&scoped=true"
import script from "./purchase.vue?vue&type=script&lang=js"
export * from "./purchase.vue?vue&type=script&lang=js"
import style0 from "./purchase.vue?vue&type=style&index=0&id=db9a303e&prod&scoped=true&lang=css"
import style1 from "./purchase.vue?vue&type=style&index=1&id=db9a303e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9a303e",
  null
  
)

export default component.exports